// Default menu settings configurations

import { Constants } from "src/app/share/utils/constants";

export interface MenuItem {
  title: string;
  icon: string;
  page: string;
  isExternalLink?: boolean;
  issupportExternalLink?: boolean;
  badge: { type: string, value: string };
  submenu: {
    items: Partial<MenuItem>[];
  };
  section: string;
  roles: any[];
  mustHaveClient: boolean;
  isMailTo: boolean;
  // Oculta el ítem en el menú vertical sin quitarlo de la configuración
  excludeInVertical: boolean;
}

export interface MenuConfig {
  horizontal_menu: {
    items: Partial<MenuItem>[]
  };
  vertical_menu: {
    items: Partial<MenuItem>[]
  };
}

export const MenuSettingsConfig: MenuConfig = {
  horizontal_menu: {
    items: [
      /*{
        title: 'Changelog',
        icon: 'la-file',
        page: '/changelog',
        badge: { type: 'badge-danger', value: '1.1' }
      },
      {
        title: 'Templates',
        icon: 'la-television',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'Horizontal',
              page: 'null'
            },
            {
              title: 'Vertical',
              page: 'null'
            },
          ]
        }
      },
      {
        title: 'Raise Support',
        icon: 'la-support',
        page: 'https://pixinvent.ticksy.com/',
        isExternalLink: true
      },
      {
        title: 'Documentaion',
        icon: 'la-text-height',
        page: 'https://modern-admin-docs.web.app/html/ltr/documentation/index.html',
        isExternalLink: true,
      }*/
    ]
  },
  vertical_menu: {
    items: [
      {
        title: 'MENU_ITEM.CLIENTS',
        icon: 'la-users',
        page: '/clients',
        roles: [Constants.ROLES.SUPERADMIN],
        mustHaveClient: false
      },
      {
        title: 'MENU_ITEM.INICIO',
        icon: 'la-home',
        page: '/home',
        roles: [Constants.ROLES.ADMIN, Constants.ROLES.LEADER],
        mustHaveClient: true
        //badge: { type: 'badge-danger', value: '1.1' }
      },
      {
        title: 'MENU_ITEM.DASHBOARD',
        icon: 'la-dashboard',
        page: '/dashboard',
        roles: [Constants.ROLES.SUPERADMIN, Constants.ROLES.ADMIN, Constants.ROLES.LEADER],
        mustHaveClient: true
        //badge: { type: 'badge-danger', value: '1.1' }
      },
      {
        title: 'MENU_ITEM.POLLS',
        icon: 'la-clipboard',
        page: '/polls',
        roles: [Constants.ROLES.SUPERADMIN, Constants.ROLES.ADMIN, Constants.ROLES.LEADER],
        mustHaveClient: true
      },
      {
        title: 'MENU_ITEM.IMPROVEMENTS',
        icon: 'la-magic',
        page: 'null',
        roles: [Constants.ROLES.SUPERADMIN, Constants.ROLES.ADMIN, Constants.ROLES.LEADER],
        submenu: {
          items: [
            {
              title: 'MENU_ITEM.RESOURCES',
              icon: 'la-files-o',
              page: '/resources',
              roles: [Constants.ROLES.SUPERADMIN, Constants.ROLES.ADMIN, Constants.ROLES.LEADER],
              mustHaveClient: false
            },
            {
              title: 'MENU_ITEM.ACTIONS',
              icon: 'la-exchange',
              page: '/actions',
              roles: [Constants.ROLES.SUPERADMIN, Constants.ROLES.ADMIN, Constants.ROLES.LEADER],
              mustHaveClient: false,
              excludeInVertical: true // Oculto por ahora: no se usa
            },
            {
              title: 'MENU_ITEM.MISSIONS',
              icon: 'la-rocket',
              page: '/missions',
              roles: [Constants.ROLES.ADMIN, Constants.ROLES.LEADER],
              mustHaveClient: true
            }
          ]
        }
      },
      {
        title: 'MENU_ITEM.ORGANIZATION',
        icon: 'la-users',
        page: 'null',
        roles: [Constants.ROLES.SUPERADMIN, Constants.ROLES.ADMIN, Constants.ROLES.LEADER],
        submenu: {
          items: [
            {
              title: 'MENU_ITEM.DEPARTAMENTS',
              icon: 'la-building',
              page: '/departments',
              roles: [Constants.ROLES.SUPERADMIN, Constants.ROLES.ADMIN],
              mustHaveClient: true
            },
            {
              title: 'MENU_ITEM.COLLABORATORS',
              icon: 'la-user',
              page: '/collaborators',
              roles: [Constants.ROLES.SUPERADMIN, Constants.ROLES.ADMIN, Constants.ROLES.LEADER],
              mustHaveClient: true
            },
            {
              title: 'MENU_ITEM.QUESTIONS',
              icon: 'la-question',
              page: '/questions',
              roles: [Constants.ROLES.SUPERADMIN, Constants.ROLES.ADMIN, Constants.ROLES.LEADER],
              mustHaveClient: false
            },
            {
              title: 'MENU_ITEM.KEYDRIVERS',
              icon: 'la-key',
              page: '/keydrivers',
              roles: [Constants.ROLES.SUPERADMIN, Constants.ROLES.ADMIN, Constants.ROLES.LEADER],
              mustHaveClient: false
            }
          ]
        }
      },
      {
        title: 'MENU_ITEM.SUPPORT',
        icon: 'la-envelope',
        page: 'mailto:soporte@glicinarse.com?subject=Soporte%20TLG',
        isExternalLink: false,
        roles: [Constants.ROLES.SUPERADMIN, Constants.ROLES.ADMIN, Constants.ROLES.LEADER],
        mustHaveClient: true,
        isMailTo: true
      },





      /*{
        title: 'MENU_ITEM.POLLS',
        icon: 'la-clipboard',
        page: '/pollResponse/asd',
        roles: [Constants.ROLES.SUPERADMIN, Constants.ROLES.ADMIN, Constants.ROLES.LEADER, Constants.ROLES.COLLABORATOR],
        mustHaveClient: true
      }*/
      /*{
        title: 'Changelog',
        icon: 'la-file',
        page: '/changelog',
        badge: { type: 'badge-danger', value: '1.1' }
      },
      {
        title: 'Templates',
        icon: 'la-television',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'Horizontal',
              page: 'null'
            },
            {
              title: 'Vertical',
              page: 'null'
            },
          ]
        }
      },*/
      /*{ section: 'SUPPORT', icon: 'la-ellipsis-h' },
      {
        title: 'Raise Support',
        icon: 'la-support',
        page: 'https://pixinvent.ticksy.com/',
        isExternalLink: true
      },
      {
        title: 'Documentaion',
        icon: 'la-text-height',
        page: 'https://modern-admin-docs.web.app/html/ltr/documentation/index.html',
        isExternalLink: true,
      }*/
    ]
  }

};





